var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":"primary","outlined":""}},[_c('v-icon',{attrs:{"size":"20","left":""}},[_vm._v(" "+_vm._s(_vm.typeRender.icon)+" ")]),_vm._v(" "+_vm._s(_vm.typeRender.texte)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }